import { useState } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import type { TLocalize } from '@hooks/use-localize';

const RATINGS = [1, 2, 3, 4, 5];

const DESCRIPTORS: Record<number, [string, string]> = {
    1: ['DashLabel_RatingPoor', 'Poor'],
    2: ['DashLabel_RatingFair', 'Fair'],
    3: ['DashLabel_RatingGood', 'Good'],
    4: ['DashLabel_RatingVeryGood', 'Very good'],
    5: ['DashLabel_RatingExcellent', 'Excellent'],
};

interface IProps {
    field: UseFormRegisterReturn;
    value: string;
    onClear: () => void;
    t: TLocalize;
}

const StarRating = ({ field, value, onClear, t }: IProps) => {
    const [hovered, setHovered] = useState(0);
    const selected = value !== '' ? parseInt(value, 10) : 0;
    const shown = hovered || selected;

    // A radio that is already checked fires no change event, so clicking the rating the
    // donor already gave is what takes the answer back to unanswered. The pointer is still
    // over that star, so the hover preview has to be dropped too or it stays lit.
    const handleClick = (rating: number) => {
        if (String(rating) === value) {
            onClear();
            setHovered(0);
        }
    };

    const describe = (rating: number) => t(...DESCRIPTORS[rating]);

    return (
        <div className="star-rating" onMouseLeave={() => setHovered(0)}>
            <div className="star-rating__stars">
                {RATINGS.map((rating) => (
                    <label
                        key={rating}
                        className={'star-rating__star' + (rating <= shown ? ' star-rating__star--on' : '')}
                        onMouseEnter={() => setHovered(rating)}
                    >
                        <input
                            type="radio"
                            value={rating}
                            aria-label={`${rating} - ${describe(rating)}`}
                            {...field}
                            onClick={() => handleClick(rating)}
                        />
                        <i className="fas fa-star" aria-hidden="true"></i>
                    </label>
                ))}
            </div>
            <span className="star-rating__descriptor">{shown ? describe(shown) : ''}</span>
        </div>
    );
};

export default StarRating;
